<template lang="pug">
  section.install
    h2 Установить ConPlus как часть страницы вашего сайта
    // a(href="#").link Пример страницы сайта с встроенным ConPlus
    p Скопируйте строку кода и вставьте в том месте кода страницы, в котором должен отображаться конструктор
    .box--inner.install__block
      .box--inner.install__code
        code.box__content {{ siteCode }}
      .btn--accent.install__btn(
        @click="copySiteCode()"
      ) Копировать код

    hr.box__hr
    h2 Не знаете как вставить код? Воспользуйтесь подходящей вам инструкцией:
    .box--inner.box--center
      .tutorials
        .tutorial
          .tutorial__logo-container
            img.tutorial__logo(
              alt="Сайт под управлением CMS Word Press"
              src="@/assets/images/wordpress.png"
              srcset="@/assets/images/wordpress@2x.png 2x"
            )
            p Сайт под управлением CMS Word Press
          router-link(:to="{name: 'constructors.constructor.install.docs', hash:'#wordpress'}").btn--accent.tutorial__btn Инструкция по установке
        .tutorial
          .tutorial__logo-container
            img.tutorial__logo(
              alt="Сайт без CMS (лендинг)"
              src="@/assets/images/custom.png"
              srcset="@/assets/images/custom@2x.png 2x"
            )
            p Сайт без CMS (лендинг)
          router-link(:to="{name: 'constructors.constructor.install.docs', hash:'#nocms'}").btn--accent.tutorial__btn Инструкция по установке
        .tutorial
          .tutorial__logo-container
            img.tutorial__logo(
              alt="Сайт на конструкторе (Tilda. Wix, Lpgenerator, Platformlp)"
              src="@/assets/images/tilda.png"
              srcset="@/assets/images/tilda@2x.png 2x"
            )
            p Сайт на конструкторе (Tilda. Wix, Lpgenerator, Platformlp)
          router-link(:to="{name: 'constructors.constructor.install.docs', hash:'#constructor'}").btn--accent.tutorial__btn Инструкция по установке
      // p Не нашли своего варианта? Задайте вопрос в службу поддержки
      // button.btn(
          @click="openEmailModal('', false)"
        ) Техническая поддержка

    hr.box__hr
    // .box--inner.box--center
      h2 Установить ConPlus как приложение Вконтакте или Facebook
      span.social-examples__links
        a.link(
          href="#"
          @click.prevent="zoomExampleImage(images.vk)"
        ) Пример приложения ConPlus Вконтакте
        |,
        a.link(
          href="#"
          @click.prevent="zoomExampleImage(images.fb)"
        ) Пример приложения ConPlus Facebook
      p Отправьте запрос и мы пришлем вам на почту инструкции по созданию приложения в соц. сети
      button.btn(
        @click="openEmailModal('Запрос на помощь в создании приложения', true)"
      ) Запрос на помощь в создании приложения
    // hr.box__hr
    h2 ConPlus как отдельная страница на нашем сайте constructorplus.ru
    p У вас нет сайта?
      br
      | Мы сделали для вас отдельную страницу с полностью рабочим конструктором.
    p Вы можете отправлять ссылку на эту страницу своим клиентам в мессенджерах или по email.
      br
      | И использовать ConPlus при замерах на своем планшете или даже в смартфоне
    // .box--inner.install__block.install__code
      code {{ partnerCode }}
    .box__inner.box--center
      div
        a(:href="appUrl" target="_blank").btn Открыть страницу с вашим ConPlus
        button.btn(
          @click="copyAppLink()"
        ) Скопировать ссылку на страницу
    // hr.box__hr
    // .box--inner.box--center
      h2.text-center НЕТ ВРЕМЕНИ ВНИКАТЬ?
      h2.text-center УСТАНОВКА НА САЙТ И НАСТРОЙКА В ПОДАРОК
        br
        | При оплате ConPlus на 6 месяцев и больше
      router-link(:to="{name: 'payments' }").btn Посмотреть тарифы
    // .btn.install__btn Техническая поддержка

    // Modals
    email-modal(
      ref="emailModal"
      :to="supportEmail"
      :topic="supportTopic"
      :disableTopic="true"
    )

    sweet-modal(ref="tutorialPopup")
      .tutorial_popup
        p Функция в разработке

    // Tutorial modal
    TutorialModal(ref="tutorial" title="Установка ConPlus")
      .tut-modal__content
        p Если вы все настроили, осталось установить. Выберите подходящий способ:
        ul
          li Как часть страницы сайта;
          li Как отдельная страница на нашем портале.
        p Изучите инструкцию по установке и вперед — за новыми клиентами!
</template>

<script>
import copy from 'copy-text-to-clipboard';
import { mapState } from 'vuex';

import EmailModal from '@/components/ui/modals/EmailModal/EmailModal.vue';
import TutorialModal from '@/components/ui/modals/TutorialModal/TutorialModal.vue';

import config from '@/config';

export default {
  data() {
    return {
      supportTopic: '',
      images: {
        vk: require('@/assets/images/vk-preview.png'),
        fb: require('@/assets/images/fb-preview.png')
      }
    };
  },

  computed: {
    ...mapState({
      supportEmail: state => state.global.supportEmail
    }),

    appUrl() {
      return config.urls.app(this.$store.getters.getToken);
    },

    siteCode() {
      return `<iframe src="${this.appUrl}" width="980px" height="745px" scrolling="no" style="border:none;"></iframe>`;
    },

    partnerCode() {
      return `https://partner.constructorplus.ru/${this.$store.getters.getToken}`;
    }
  },

  methods: {
    copySiteCode() {
      copy(this.siteCode);
      this.flashSuccess('Код скопирован в буфер обмена');
    },

    copyAppLink() {
      copy(this.appUrl);
      this.flashSuccess('Адрес скопирован в буфер обмена');
    },

    copyPartnerCode() {
      copy(this.partnerCode);
      this.flashSuccess('Ссылка скопирована в буфер обмена!');
    },

    openTutorialModal() {
      this.$refs.tutorialPopup.open();
    },

    openEmailModal(topic, disableTopic) {
      this.$refs.emailModal.open(this.supportEmail, topic, '', {
        disableTopic: disableTopic
      });
    },

    zoomExampleImage(path) {
      this.$zoom(path, {
        allowZoom: true
      });
    }
  },

  components: {
    EmailModal,
    TutorialModal
  }
};
</script>

<style lang="scss" scoped>
.install__btn {
  margin-right: 5px;
}

.tutorials {
  display: grid;
  grid-gap: 20px 20px;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
  padding: 5px 0 20px;
}

.tutorial {
  border: 1px solid #ccc;
  padding: 18px 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.tutorial__logo-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
  flex-grow: 1;

  p {
    margin: 0;
  }
}

.tutorial__logo {
  width: 50px;
  height: 50px;
  background-color: #ccc;
  margin-right: 15px;
  flex-shrink: 0;
}

.tutorial__btn {
  width: 100%;
  text-align: center;
  margin-bottom: auto;
}

.social-examples__links {
  margin-bottom: 15px;
}

@media screen and (max-width: 639px) {
  .tutorials {
    grid-template-columns: 1fr;
  }
}
</style>
